import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ce55a8e4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce55a8e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce55a8e4')) {
      api.createRecord('ce55a8e4', component.options)
    } else {
      api.reload('ce55a8e4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ce55a8e4&scoped=true", function () {
      api.rerender('ce55a8e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pluginManage/pluginTactics/index.vue"
export default component.exports